import { useMemo } from "react";
import { useUserStatus } from "@hooks/useUserStatus";
import type { TaskCompleter } from "./taskBoardMoves";

/**
 * The signed-in user as the server names them in a task's `lastDoneBy`,
 * for drops that finish a task. Null until the user loads.
 */
export const useTaskCompleter = (): TaskCompleter | null => {
    const { data: userStatus } = useUserStatus();
    const user = userStatus?.user;
    return useMemo(
        () =>
            user === undefined
                ? null
                : {
                      id: user.id,
                      name: user.name,
                      firstName: user.firstName,
                      lastName: user.lastName,
                      email: user.email,
                      avatar: user.avatar,
                      iconColor: user.iconColor,
                  },
        [user],
    );
};
